export default "__VITE_ASSET__0jlaL3qY__"